import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/success.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4323bdb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Berhasil")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "success",
    src: _imports_0
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "message" }, "Profile berhasil diupdate")
], -1))
const _hoisted_7 = { class: "col-sm-12 d-flex justify-content-between" }
const _hoisted_8 = { class: "content w-full bg-white" }
const _hoisted_9 = { class: "form p-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "form__header-title" }, "Selamat datang di Growth Center"),
  /*#__PURE__*/_createElementVNode("p", { class: "form__header-sub-title" }, " Mohon lengkapi data diri untuk melanjutkan ")
], -1))
const _hoisted_11 = { class: "form__content" }
const _hoisted_12 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Name Lengkap "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_14 = { class: "text-danger" }
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_18 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "placeOfBirth",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Tempat Lahir "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_20 = { class: "text-danger" }
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "dateOfBirth",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Tanggal Lahir "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_24 = { class: "text-danger" }
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "provinceId",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Domisili "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_28 = { class: "text-danger" }
const _hoisted_29 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_30 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "gender",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Jenis Kelamin "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "text-danger" }
const _hoisted_34 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_35 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Nomor Telepon "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_37 = { class: "text-danger" }
const _hoisted_38 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_40 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastEducation",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Pendidikan Terakhir "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "text-danger" }
const _hoisted_44 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_45 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_46 = {
  for: "institutionId",
  class: "text-sm text-primary-gc font-semibold mb-2"
}
const _hoisted_47 = {
  key: 0,
  class: "text-sm text-red-500 font-semibold"
}
const _hoisted_48 = { class: "text-danger" }
const _hoisted_49 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = { class: "flex justify-between" }
const _hoisted_52 = { class: "flex flex-column mr-1" }
const _hoisted_53 = { role: "group" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lastEducationFromYear",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Tahun Mulai "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_55 = { class: "text-danger" }
const _hoisted_56 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_57 = { class: "flex flex-column" }
const _hoisted_58 = { role: "group" }
const _hoisted_59 = {
  for: "lastEducationToYear",
  class: "text-sm text-primary-gc font-semibold mb-2"
}
const _hoisted_60 = {
  key: 0,
  class: "text-sm text-red-500 font-semibold"
}
const _hoisted_61 = { class: "text-danger" }
const _hoisted_62 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_64 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "profession",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Pekerjaan saat ini "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_66 = ["value"]
const _hoisted_67 = { class: "text-danger" }
const _hoisted_68 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_69 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "industryId",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Bidang Industri "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_71 = { class: "text-danger" }
const _hoisted_72 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_73 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "workExperienceYear",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Pengalaman Bekerja (Dalam Tahun) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-500 font-semibold" }, "*")
], -1))
const _hoisted_75 = { class: "text-danger" }
const _hoisted_76 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_78 = {
  role: "group",
  class: "mb-6"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "maritalStatus",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, " Status Perkawinan ", -1))
const _hoisted_80 = ["value"]
const _hoisted_81 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BModal = _resolveComponent("BModal")!
  const _component_GcHeader = _resolveComponent("GcHeader")!
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_BInputGroup = _resolveComponent("BInputGroup")!
  const _component_vue_bootstrap_typeahead = _resolveComponent("vue-bootstrap-typeahead")!
  const _component_BFormGroup = _resolveComponent("BFormGroup")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_BFormCheckbox = _resolveComponent("BFormCheckbox")!
  const _component_BButton = _resolveComponent("BButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BModal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModal) = $event)),
      id: "success-modal",
      "hide-header": "",
      "hide-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn regular w-100 btn-warning",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, " OK ")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_GcHeader, { "profile-data": _ctx.profileData }, null, 8, ["profile-data"]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_BInputGroup, null, {
              default: _withCtx(() => [
                _createVNode(_component_BFormInput, {
                  modelValue: _ctx.formData.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event)),
                  state: _ctx.v$.name.$errors.length === 0 ? null : false,
                  id: "name",
                  type: "text",
                  placeholder: "Masukkan nama lengkap anda",
                  onInput: _ctx.v$.name.$touch
                }, null, 8, ["modelValue", "state", "onInput"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.name.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("small", _hoisted_14, _toDisplayString(error.$message), 1)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.name, (err, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: index
              }, [
                err
                  ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(err), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_BInputGroup, null, {
              default: _withCtx(() => [
                _createVNode(_component_BFormInput, {
                  modelValue: _ctx.formData.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.email) = $event)),
                  id: "email",
                  type: "text",
                  placeholder: "username@example.com",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            (_ctx.frmData.placeOfBirth || !_ctx.focus.placeOfBirth)
              ? (_openBlock(), _createBlock(_component_BInputGroup, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BFormInput, {
                      modelValue: _ctx.frmData.placeOfBirth,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.frmData.placeOfBirth) = $event)),
                      id: "placeOfBirth",
                      type: "text",
                      placeholder: "Masukkan tempat lahir anda",
                      onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.focus.placeOfBirth = true)),
                      onInput: _ctx.v$.place_of_birth.$touch
                    }, null, 8, ["modelValue", "onInput"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_BFormGroup, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vue_bootstrap_typeahead, {
                      modelValue: _ctx.formData.place_of_birth,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.place_of_birth) = $event)),
                      data: _ctx.cityData,
                      serializer: (s) => s.text,
                      id: "placeOfBirth",
                      placeholder: "Masukkan tempat lahir anda",
                      onInput: _ctx.searchCity,
                      onHit: _ctx.updateCity
                    }, null, 8, ["modelValue", "data", "serializer", "onInput", "onHit"])
                  ]),
                  _: 1
                })),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.place_of_birth.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("small", _hoisted_20, _toDisplayString(error.$message), 1)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.place_of_birth, (err, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: index
              }, [
                err
                  ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(err), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_BFormGroup, null, {
              default: _withCtx(() => [
                _createVNode(_component_Datepicker, {
                  modelValue: _ctx.formData.date_of_birth,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.date_of_birth) = $event)),
                  id: "dateOfBirth",
                  placeholder: "Masukkan tanggal lahir anda",
                  class: "form-control",
                  "input-format": "dd-MM-yyyy",
                  typeable: true,
                  onInput: _ctx.v$.date_of_birth.$touch
                }, null, 8, ["modelValue", "onInput"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.date_of_birth.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("small", _hoisted_24, _toDisplayString(error.$message), 1)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.date_of_birth, (err, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: index
              }, [
                err
                  ? (_openBlock(), _createElementBlock("small", _hoisted_25, _toDisplayString(err), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            (_ctx.frmData.provinceId || !_ctx.focus.provinceId)
              ? (_openBlock(), _createBlock(_component_BInputGroup, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BFormInput, {
                      modelValue: _ctx.frmData.provinceId,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.frmData.provinceId) = $event)),
                      id: "provinceId",
                      type: "text",
                      placeholder: "Masukkan provinsi",
                      onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.focus.provinceId = true)),
                      onInput: _ctx.v$.province_id.$touch
                    }, null, 8, ["modelValue", "onInput"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_BFormGroup, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vue_bootstrap_typeahead, {
                      modelValue: _ctx.formData.province_id,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.province_id) = $event)),
                      data: _ctx.provinceData,
                      serializer: (s) => s.text,
                      id: "provinceId",
                      placeholder: "Masukkan provinsi",
                      onInput: _ctx.searchProvince,
                      onHit: _ctx.updateProvince
                    }, null, 8, ["modelValue", "data", "serializer", "onInput", "onHit"])
                  ]),
                  _: 1
                })),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.province_id.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("small", _hoisted_28, _toDisplayString(error.$message), 1)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.province_id, (err, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: index
              }, [
                err
                  ? (_openBlock(), _createElementBlock("small", _hoisted_29, _toDisplayString(err), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode(_component_BInputGroup, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.gender) = $event)),
                  class: _normalizeClass(`form-select ${
                  _ctx.v$.gender.$errors.length === 0 ? '' : 'is-invalid'
                }`),
                  id: "gender",
                  onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$.gender.$touch && _ctx.v$.gender.$touch(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderData, (item, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: item.value
                    }, _toDisplayString(item.text), 9, _hoisted_32))
                  }), 128))
                ], 34), [
                  [_vModelSelect, _ctx.formData.gender]
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.gender.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("small", _hoisted_33, _toDisplayString(error.$message), 1)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.gender, (err, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: index
              }, [
                err
                  ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(err), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode(_component_BInputGroup, null, {
              default: _withCtx(() => [
                _createVNode(_component_BFormInput, {
                  modelValue: _ctx.formData.phone,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.phone) = $event)),
                  state: _ctx.v$.phone.$errors.length === 0 ? null : false,
                  id: "phone",
                  type: "text",
                  maxlength: "15",
                  placeholder: "Masukkan nomor telepon anda",
                  onInput: _ctx.v$.phone.$touch
                }, null, 8, ["modelValue", "state", "onInput"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.phone.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("small", _hoisted_37, _toDisplayString(error.$message), 1)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.phone, (err, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: index
              }, [
                err
                  ? (_openBlock(), _createElementBlock("small", _hoisted_38, _toDisplayString(err), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createVNode(_component_BInputGroup, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.last_education) = $event)),
                  class: _normalizeClass(`form-select ${
                  _ctx.v$.last_education.$errors.length === 0 ? '' : 'is-invalid'
                }`),
                  id: "lastEducation",
                  onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.changeLastEducation && _ctx.changeLastEducation(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastEducationData, (item, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: item.value
                    }, _toDisplayString(item.text), 9, _hoisted_42))
                  }), 128))
                ], 34), [
                  [_vModelSelect, _ctx.formData.last_education]
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.last_education.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("small", _hoisted_43, _toDisplayString(error.$message), 1)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.last_education, (err, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: index
              }, [
                err
                  ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString(err), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (
              _ctx.formData.last_education !== null &&
              _ctx.formData.last_education !== 'Tidak Bersekolah'
            )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, [
                    _createTextVNode(" Institusi Pendidikan "),
                    (_ctx.universityEducation.includes(_ctx.formData.last_education))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.frmData.institutionId || !_ctx.focus.institutionId)
                    ? (_openBlock(), _createBlock(_component_BInputGroup, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BFormInput, {
                            modelValue: _ctx.frmData.institutionId,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.frmData.institutionId) = $event)),
                            id: "institutionId",
                            type: "text",
                            placeholder: "Masukkan institusi pendidikan",
                            onFocus: _cache[17] || (_cache[17] = ($event: any) => (_ctx.focus.institutionId = true)),
                            onInput: _ctx.v$.institution_id.$touch
                          }, null, 8, ["modelValue", "onInput"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_BFormGroup, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_vue_bootstrap_typeahead, {
                            modelValue: _ctx.formData.institution_id,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.institution_id) = $event)),
                            data: _ctx.institutionData,
                            serializer: (s) => s.text,
                            id: "institutionId",
                            placeholder: "Masukkan institusi pendidikan",
                            onInput: _ctx.searchInstitution,
                            onHit: _ctx.updateInstitution
                          }, null, 8, ["modelValue", "data", "serializer", "onInput", "onHit"])
                        ]),
                        _: 1
                      })),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.institution_id.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("small", _hoisted_48, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.institution_id, (err, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: index
                    }, [
                      err
                        ? (_openBlock(), _createElementBlock("small", _hoisted_49, _toDisplayString(err), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createVNode(_component_BFormGroup, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Datepicker, {
                              modelValue: _ctx.formData.last_education_from_year,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.last_education_from_year) = $event)),
                              typeable: true,
                              id: "lastEducationFromYear",
                              class: "form-control",
                              "input-format": "yyyy",
                              "minimum-view": "year",
                              onInput: _ctx.v$.last_education_from_year.$touch
                            }, null, 8, ["modelValue", "onInput"])
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.last_education_from_year.$errors, (error) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "input-errors",
                            key: error.$uid
                          }, [
                            _createElementVNode("small", _hoisted_55, _toDisplayString(error.$message), 1)
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.last_education_from_year, (err, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "input-errors",
                            key: index
                          }, [
                            err
                              ? (_openBlock(), _createElementBlock("small", _hoisted_56, _toDisplayString(err), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("label", _hoisted_59, [
                          _createTextVNode(" Tahun Berakhir "),
                          (_ctx.formData.stillEducation !== 'true')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, " * "))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_BFormGroup, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Datepicker, {
                              modelValue: _ctx.formData.last_education_to_year,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.last_education_to_year) = $event)),
                              typeable: true,
                              disabled: _ctx.formData.stillEducation === 'true',
                              id: "lastEducationToYear",
                              class: "form-control",
                              "input-format": "yyyy",
                              "minimum-view": "year",
                              onInput: _ctx.v$.last_education_to_year.$touch
                            }, null, 8, ["modelValue", "disabled", "onInput"])
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.last_education_to_year.$errors, (error) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "input-errors",
                            key: error.$uid
                          }, [
                            _createElementVNode("small", _hoisted_61, _toDisplayString(error.$message), 1)
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.last_education_to_year, (err, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "input-errors",
                            key: index
                          }, [
                            err
                              ? (_openBlock(), _createElementBlock("small", _hoisted_62, _toDisplayString(err), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_BFormGroup, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_BFormCheckbox, {
                      modelValue: _ctx.formData.stillEducation,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.stillEducation) = $event)),
                      value: "true",
                      onChange: _ctx.updateStillEducation
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Saya sedang bersekolah disini ")
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _hoisted_65,
            _createVNode(_component_BInputGroup, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.profession) = $event)),
                  class: _normalizeClass(`form-select ${
                  _ctx.v$.profession.$errors.length === 0 ? '' : 'is-invalid'
                }`),
                  id: "profession",
                  onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.changeProfession && _ctx.changeProfession(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professionData, (item, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: item.value
                    }, _toDisplayString(item.text), 9, _hoisted_66))
                  }), 128))
                ], 34), [
                  [_vModelSelect, _ctx.formData.profession]
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.profession.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("small", _hoisted_67, _toDisplayString(error.$message), 1)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.profession, (err, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: index
              }, [
                err
                  ? (_openBlock(), _createElementBlock("small", _hoisted_68, _toDisplayString(err), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (
              _ctx.formData.profession !== null &&
              _ctx.formData.profession !== 'Belum/Tidak Bekerja' &&
              _ctx.formData.profession !== 'Pelajar/Mahasiswa'
            )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_69, [
                  _hoisted_70,
                  (_ctx.frmData.industryId || !_ctx.focus.industryId)
                    ? (_openBlock(), _createBlock(_component_BInputGroup, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BFormInput, {
                            modelValue: _ctx.frmData.industryId,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.frmData.industryId) = $event)),
                            id: "industryId",
                            type: "text",
                            placeholder: "Masukkan industri",
                            onFocus: _cache[25] || (_cache[25] = ($event: any) => (_ctx.focus.industryId = true)),
                            onInput: _ctx.v$.industry_id.$touch
                          }, null, 8, ["modelValue", "onInput"])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_BFormGroup, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_vue_bootstrap_typeahead, {
                            modelValue: _ctx.formData.industry_id,
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.industry_id) = $event)),
                            data: _ctx.industryData,
                            serializer: (s) => s.text,
                            id: "industryId",
                            placeholder: "Masukkan industri",
                            onInput: _ctx.searchIndustry,
                            onHit: _ctx.updateIndustry
                          }, null, 8, ["modelValue", "data", "serializer", "onInput", "onHit"])
                        ]),
                        _: 1
                      })),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.industry_id.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("small", _hoisted_71, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.industry_id, (err, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: index
                    }, [
                      err
                        ? (_openBlock(), _createElementBlock("small", _hoisted_72, _toDisplayString(err), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _hoisted_74,
                  _createVNode(_component_BInputGroup, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_BFormInput, {
                        modelValue: _ctx.formData.work_experience_year,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.work_experience_year) = $event)),
                        state: 
                    _ctx.v$.work_experience_year.$errors.length === 0 ? null : false
                  ,
                        id: "workExperienceYear",
                        type: "number",
                        placeholder: "Masukkan pengalaman bekerja anda (cth. '3')",
                        onInput: _ctx.v$.work_experience_year.$touch
                      }, null, 8, ["modelValue", "state", "onInput"])
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.work_experience_year.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("small", _hoisted_75, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.work_experience_year, (err, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: index
                    }, [
                      err
                        ? (_openBlock(), _createElementBlock("small", _hoisted_76, _toDisplayString(err), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_77,
          _createElementVNode("div", _hoisted_78, [
            _hoisted_79,
            _createVNode(_component_BInputGroup, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.marital_status) = $event)),
                  class: "form-select",
                  id: "maritalStatus"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maritalStatusData, (item, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: item.value
                    }, _toDisplayString(item.text), 9, _hoisted_80))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.formData.marital_status]
                ])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.marital_status, (err, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: index
              }, [
                err
                  ? (_openBlock(), _createElementBlock("small", _hoisted_81, _toDisplayString(err), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createVNode(_component_BButton, {
            variant: "warning",
            class: "w-full text-center text-sm font-semibold py-2",
            disabled: _ctx.isLoading,
            onClick: _ctx.updateProfile
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Simpan ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ])
  ]))
}